<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { generateUUID } from '@common/utils/strings';

  export let row = {};

  const id = generateUUID();
</script>

<div
  class="intent"
  class:low={row.leadscore <= 5}
  class:medium={row.leadscore > 5 && row.leadscore <= 15}
  class:high={row.leadscore > 15}
>
  <span id="tooltip-{id}-intent">
    {#if row.leadscore <= 5}
      ❄️ {$format('label.INTENT_LOW')}
    {:else if row.leadscore > 5 && row.leadscore <= 15}
      🟡 {$format('label.INTENT_MODERATE')}
    {:else if row.leadscore > 15}
      🔥 {$format('label.INTENT_HIGH')}
    {/if}
  </span>

  <Tooltip target="tooltip-{id}-intent">
    {$format('label.SCORE')}
    {(row.leadscore || 0).toLocaleString()}
  </Tooltip>
</div>

<style lang="scss">
  .intent {
    border-radius: calc(var(--border-radius-base) + 1px);
    display: inline-block;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;

    &.low {
      background-color: var(--color-blue-0);
    }

    &.medium {
      background-color: var(--color-orange-0);
    }

    &.high {
      background-color: var(--color-red-0);
    }
  }
</style>
